import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { GruppiComponent } from 'src/app/admin/gruppi/gruppi.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => GruppoPickerComponent) },
  ],
  selector: 'gruppo-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class GruppoPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(GruppiComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
